import React from 'react';

import { Box, VStack, Text, useToken, Flex } from 'quotient';

import { NavigationItemComponent } from './NavigationItemComponent';
import { NavigationItemType, NavigationConfig } from './types';

interface NavigationMainSectionProps {
  section: NavigationConfig;
  selectedItem: NavigationItemType | null;
  hasSecondaryContent: boolean;
  onItemClick: (item: NavigationItemType) => void;
}

export const NavigationMainSection: React.FC<NavigationMainSectionProps> = ({
  hasSecondaryContent,
  section,
  selectedItem,
  onItemClick,
}) => {
  const [borderColor, normalTextColor] = useToken('colors', [
    'primaryNeutral.400', // Border color
    'primaryNeutral.900', // Normal text
  ]);

  const SectionTitleComponent = section.sectionTitleComponent;

  return (
    <Box
      _last={{ borderBottom: 'none' }}
      borderBottom={hasSecondaryContent ? '1px solid' : 'none'}
      borderBottomColor={borderColor}
      className="navigation-main-section"
      flex="0 0 auto"
      maxH={hasSecondaryContent ? '50%' : '100%'}
      overflowY="auto"
      pb={6}
    >
      <Flex align="center" direction="row" justify="space-between" m={0} pb={4} pt={6}>
        <Text color={normalTextColor} fontSize="16px" fontWeight="600" m={0}>
          {section.title}
        </Text>
        {SectionTitleComponent && <SectionTitleComponent />}
      </Flex>
      <VStack align="stretch" spacing={0}>
        {section.items
          .filter((item) => !item.hidden)
          .map((item) => (
            <NavigationItemComponent
              isSelected={selectedItem?.id === item.id}
              item={item}
              key={item.id}
              onClick={onItemClick}
            />
          ))}
      </VStack>
    </Box>
  );
};
